import React, { useEffect, useState } from "react";
import { 
  Layout, 
  Typography, 
  Divider, 
  Row, 
  Col, 
  Card, 
  Button, 
  Input, 
  notification, 
  Modal,
  Image
} from "antd";
import { 
  SafetyCertificateOutlined, 
  FilePdfOutlined, 
  MailOutlined, 
  PhoneOutlined,
  EnvironmentOutlined
} from "@ant-design/icons";
import { useLocation } from "react-router-dom";

import Header from "./Header";
import Footer from "./Footer";

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

const COLORS = {
  accent: "#c9b37e",
  accentDark: "#b3a068",
  bgLight: "#f5f7fa",
  textSecondary: "#666"
};

// Sabhi members ke liye ek hi dummy image use kar rahe hain
const teamMembers = [
  { name: "Mr. Yogesh Agarwal", role: "Director", img: "/man.jpg" },
  { name: "Mr. Bhavit Agarwal", role: "Director", img: "/man.jpg" },
  { name: "Mr. Saurbh Agarwal", role: "Director", img: "/man.jpg" },
  { name: "Mr. Himanshu Agarwal", role: "Director", img: "/man.jpg" },
  { name: "Ms. Parul Agarwal", role: "Director", img: "/man.jpg" },
  { name: "Ms. Khushi Agarwal", role: "Marketing Head", img: "/man.jpg" },
  { name: "Mr. Ashish Kumar Managal", role: "BDM / Chief Accountant", img: "/man.jpg" },
  { name: "Mr. Sanjeev Singh Baghel", role: "Technical Engineer", img: "/man.jpg" },
  { name: "Mr. Deepak Sharma", role: "Offline Marketing", img: "/man.jpg" },
  { name: "Mr. Arvind Sharma", role: "Supervisor", img: "/man.jpg" },
  { name: "Mr. Komal Sharma", role: "Supervisor", img: "/man.jpg" },
];

const certificates = [
  { title: "JP HOLLANDWOVEN QMS", file: "JP HOLLANDWOVEN QMS.pdf" },
  { title: "JP HOLLANDWOVEN OHSMS", file: "JP HOLLANDWOVEN OHSMS.pdf" },
  { title: "JP HOLLANDWOVEN EMS", file: "JP HOLLANDWOVEN EMS.pdf" },
  { title: "ISO 45001", file: "ISO 45001.pdf" },
  { title: "ISO 9001", file: "ISO 9001.pdf" },
  { title: "Factory Act License 2026-2029", file: "factory act licince 2026-2029.pdf" },
];

function OurCompany() {
  const { hash } = useLocation();
  const [pdfModalOpen, setPdfModalOpen] = useState(false);
  const [currentPdf, setCurrentPdf] = useState(null);

  // Handle scrolling to sections
  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace("#", ""));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [hash]);

  const openPdfModal = (file, title) => {
    setCurrentPdf({ file, title });
    setPdfModalOpen(true);
  };

  const onFinish = () =>
    notification.success({
      message: "Message Sent",
      description: "Our team will contact you shortly.",
    });

  /* ================= CONTACT FORM COMPONENT ================= */
  const ContactForm = () => (
    <Card
      title="Send us a Message"
      bordered={false}
      styles={{
        header: { textAlign: "center", color: COLORS.accentDark, fontWeight: 700, fontSize: 18 },
        body: { padding: "40px", display: 'flex', flexDirection: 'column', justifyContent: 'center' },
      }}
      style={{
        width: "100%",  
        height: "100%", 
        borderRadius: 16,
        boxShadow: "0 10px 30px rgba(0,0,0,.08)",
      }}
    >
      <form
        action="https://formsubmit.co/contactus@jphollandwoven.com"
        method="POST"
        onSubmit={onFinish}
      >
        <Input name="name" size="large" placeholder="Your Name" style={{borderRadius: 8}} required />
        <br /><br />
        <Input name="email" size="large" placeholder="Email Address" prefix={<MailOutlined style={{color: COLORS.accent}} />} style={{borderRadius: 8}} required />
        <br /><br />
        <Input name="mobile" size="large" placeholder="Mobile Number" prefix={<PhoneOutlined style={{color: COLORS.accent}} />} style={{borderRadius: 8}} required />
        <br /><br />
        <Input.TextArea name="message" rows={5} placeholder="How can we help you?" style={{borderRadius: 8, resize: 'none'}} />
        <br /><br />
        <input type="hidden" name="_captcha" value="false" />
        <input type="hidden" name="_template" value="table" />
        <Button
          htmlType="submit"
          block
          size="large"
          style={{
            height: 50,
            background: COLORS.accentDark,
            border: "none",
            fontWeight: 700,
            color: "#fff",
            borderRadius: 8,
            marginTop: 10
          }}
        >
          SEND MESSAGE
        </Button>
      </form>
    </Card>
  );

  /* ================= TEAM CARD COMPONENT ================= */
  const TeamCard = ({ member }) => (
    <Card 
      hoverable
      bordered={false}
      style={{ 
        width: 280, 
        textAlign: "center", 
        borderRadius: 16,
        boxShadow: "0 10px 20px rgba(0,0,0,0.05)",
        margin: "0 15px", 
        flexShrink: 0
      }}
      bodyStyle={{ padding: "30px 20px" }}
    >
      <div style={{ marginBottom: 20 }}>
        <img 
          src={member.img} 
          alt={member.name}
          style={{ 
            width: 100, 
            height: 100, 
            borderRadius: "50%", 
            objectFit: "cover",
            border: `3px solid ${COLORS.accent}40`
          }} 
        />
      </div>
      <Title level={5} style={{ marginBottom: 5, fontSize: 17, minHeight: 48, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {member.name}
      </Title>
      <Text type="secondary" strong style={{ color: COLORS.accentDark, fontSize: 13, textTransform: 'uppercase' }}>
        {member.role}
      </Text>
    </Card>
  );

  return (
    <Layout>
      <Header />

      {/* Removed paddingTop here to eliminate white gap */}
      <Content style={{ background: "#fff", minHeight: "100vh" }}>
        
        {/* ================= BANNER ================= */}
        {/* Added marginTop: 88px here to account for fixed header */}
        <div style={{ 
          marginTop: 0, 
          width: "100%", 
          height: "90vh", // Fixed height as requested
          position: "relative" 
        }}>
          <img 
            src="/ourcompany.png" 
            alt="Our Company Banner" 
            style={{ 
              width: "100%", 
              height: "100%", 
              objectFit: "cover", 
              objectPosition: "center" 
            }} 
          />
          <div style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(to bottom, rgba(0,0,0,0.1), rgba(0,0,0,0.5))",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            padding: 20
          }}>
            <Title style={{ color: "white", fontSize: 56, margin: 0, letterSpacing: 1, textTransform: 'uppercase', textAlign: 'center', textShadow: "0 2px 10px rgba(0,0,0,0.3)" }}>
              Our Company
            </Title>
            <Paragraph style={{ color: "#fff", fontSize: 22, marginTop: 10, fontWeight: 300, textAlign: 'center', opacity: 0.9 }}>
              Building Trust Through Quality & Integrity Since Inception
            </Paragraph>
          </div>
        </div>

        <div style={{ maxWidth: 1200, margin: "0 auto", padding: "100px 24px" }}>
          
          {/* ================= ABOUT US ================= */}
          <div id="about-us">
            <Row gutter={[64, 48]} align="middle">
              <Col xs={24} md={12}>
                <Text strong style={{ color: COLORS.accent, letterSpacing: 2, textTransform: 'uppercase' }}>Who We Are</Text>
                <Title level={2} style={{ marginTop: 10, marginBottom: 30 }}>Masters of Stone Storage Fabrication</Title>
                <Paragraph style={{ fontSize: 17, lineHeight: 1.8, color: COLORS.textSecondary, textAlign: "justify" }}>
                  JP Hollandwoven Private Limited is a premier manufacturer specializing in heavy-duty stone storage solutions. 
                  With a commitment to engineering excellence, we transform high-quality raw materials into robust 
                  A-Frames, Bundle Racks, and Display Systems that stand the test of time.
                </Paragraph>
                <Paragraph style={{ fontSize: 17, lineHeight: 1.8, color: COLORS.textSecondary, textAlign: "justify" }}>
                  Located in the industrial hub of Greater Noida, our facility is equipped with state-of-the-art machinery 
                  supervised by industry veterans. We don't just fabricate metal; we create infrastructure that 
                  supports the weight of your business.
                </Paragraph>
              </Col>
              <Col xs={24} md={12}>
                <div style={{ padding: 20, background: COLORS.bgLight, borderRadius: 24 }}>
                 <Image 
                   src="/factory.png" 
                   alt="About Us" 
                   style={{ width: "100%", borderRadius: 16, boxShadow: "0 20px 40px rgba(0,0,0,0.1)" }} 
                   preview={false}
                 />
                </div>
              </Col>
            </Row>
          </div>
        </div>

        <Divider style={{ margin: 0 }} />

        {/* ================= TEAM CONTINUOUS MARQUEE ================= */}
        <div id="team" style={{ background: COLORS.bgLight, padding: "80px 0", overflow: "hidden" }}>
          <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 24px", textAlign: "center", marginBottom: 50 }}>
             <Text strong style={{ color: COLORS.accent, letterSpacing: 2, textTransform: 'uppercase' }}>The people behind the quality</Text>
            <Title level={2} style={{margin: "10px 0"}}>Our Leadership & Team</Title>
          </div>

          {/* Marquee Container */}
          <div className="marquee-container" style={{ display: 'flex', width: '100%', overflow: 'hidden' }}>
            <div className="marquee-content">
              {teamMembers.map((member, index) => <TeamCard key={`a-${index}`} member={member} />)}
              {teamMembers.map((member, index) => <TeamCard key={`b-${index}`} member={member} />)}
            </div>
          </div>
        </div>

        <div style={{ maxWidth: 1200, margin: "0 auto", padding: "100px 24px" }}>
          {/* ================= CERTIFICATES ================= */}
          <div id="certificates">
            <div style={{ textAlign: 'center', marginBottom: 50 }}>
              <Title level={2}>Certifications & Standards</Title>
              <Paragraph style={{ fontSize: 16, color: COLORS.textSecondary }}>
                We adhere to international standards of quality and safety. Click to view certificates.
              </Paragraph>
            </div>

            <Row gutter={[32, 32]}>
              {certificates.map((cert, index) => (
                <Col xs={24} sm={12} md={8} key={index}>
                  <Card 
                    hoverable 
                    bordered={false} 
                    onClick={() => openPdfModal(cert.file, cert.title)}
                    style={{ 
                      background: "#fff", 
                      borderRadius: 12, 
                      height: "100%",
                      boxShadow: "0 5px 15px rgba(0,0,0,0.08)",
                      textAlign: "center",
                      cursor: "pointer",
                      transition: "all 0.3s ease"
                    }}
                    bodyStyle={{ padding: "30px 20px", display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%', justifyContent: 'center' }}
                  >
                    <div style={{ 
                      background: `${COLORS.accent}20`, 
                      padding: 20, 
                      borderRadius: "50%", 
                      marginBottom: 20 
                    }}>
                      <SafetyCertificateOutlined style={{ fontSize: 36, color: COLORS.accentDark }} />
                    </div>
                    <Title level={5} style={{ margin: "0 0 16px", flexGrow: 1, display: 'flex', alignItems: 'center' }}>{cert.title}</Title>
                    <Button type="primary" ghost icon={<FilePdfOutlined />} style={{ borderColor: COLORS.accentDark, color: COLORS.accentDark }}>
                      View Document
                    </Button>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>

          <Divider style={{ margin: "100px 0" }} />

          {/* ================= CTA SECTION ================= */}
          <div id="cta-section">
             <Card 
               bordered={false}
               style={{ 
                 background: `linear-gradient(135deg, #282c34 0%, #1a1d24 100%)`, 
                 borderRadius: 24, 
                 marginBottom: 100,
                 boxShadow: "0 20px 40px rgba(0,0,0,0.2)"
               }}
               bodyStyle={{ padding: "60px 40px" }}
             >
               <Row gutter={[40, 40]} align="middle">
                 <Col xs={24} md={16}>
                    <Title level={2} style={{ color: "white", marginBottom: 16 }}>Ready to upgrade your storage?</Title>
                    <Paragraph style={{ color: "rgba(255,255,255,0.8)", fontSize: 18, maxWidth: 600 }}>
                      Get in touch today for custom fabrication quotes, bulk orders, or technical consultations.
                    </Paragraph>
                 </Col>
                 <Col xs={24} md={8} style={{ textAlign: "right" }}>
                    <Button 
                      size="large" 
                      style={{ 
                        height: 56, 
                        padding: "0 48px", 
                        background: COLORS.accent, 
                        border: "none", 
                        color: "#000", 
                        fontWeight: 700,
                        fontSize: 16,
                        borderRadius: 12
                      }}
                      onClick={() => {
                        document.getElementById('contact-us-section').scrollIntoView({ behavior: 'smooth' });
                      }}
                    >
                      Get in Touch Now
                    </Button>
                 </Col>
               </Row>
             </Card>
          </div>

          {/* ================= CONTACT SECTION ================= */}
          <div id="contact-us-section">
            <div style={{ textAlign: 'center', marginBottom: 50 }}>
               <Text strong style={{ color: COLORS.accent, letterSpacing: 2, textTransform: 'uppercase' }}>locations & connect</Text>
              <Title level={2} style={{ marginTop: 10 }}>Contact Us & Factory Address</Title>
            </div>
            
            <Row gutter={[40, 40]} align="stretch">
              
              {/* WIDER FORM COLUMN (lg={15}) */}
              <Col xs={24} lg={15} style={{ display: 'flex' }}>
                 <ContactForm />
              </Col>

              {/* MAP COLUMN (lg={9}) */}
              <Col xs={24} lg={9} style={{ display: 'flex' }}>
                <Card 
                  title={<span><EnvironmentOutlined style={{color: COLORS.accent}} /> Visit Our Factory</span>}
                  bordered={false} 
                  styles={{ header: { fontSize: 18, fontWeight: 700 } }}
                  style={{ 
                    width: "100%", 
                    height: "100%", 
                    borderRadius: 16, 
                    boxShadow: "0 10px 30px rgba(0,0,0,.08)",
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                  bodyStyle={{ 
                    padding: 0, 
                    flex: 1,
                    display: 'flex', 
                    flexDirection: 'column' 
                  }}
                >
                  <div style={{ padding: "24px 24px 0" }}>
                    <Paragraph style={{ fontSize: 16, color: COLORS.textSecondary }}>
                      <strong>JP Hollandwoven Pvt. Ltd.</strong><br />
                      Khata No. 225, Khasra No. 74, Village - Talabpur Urf Hathipur, 
                      Paragna and Tehsil Dadri, Gautam Budh Nagar, UP (201301)
                    </Paragraph>
                  </div>
                  <div style={{ flex: 1, minHeight: 300, width: '100%', background: COLORS.bgLight }}>
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14009.347714466676!2d77.48714185245521!3d28.61966241074464!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cedb96aaaaaab%3A0x7f914b31a7af81!2sJP%20HOLLANDWOVEN%20PRIVATE%20LIMITED!5e0!3m2!1sen!2sin!4v1770622831347!5m2!1sen!2sin"
                      width="100%" 
                      height="100%" 
                      style={{ border: 0, display: "block" }} 
                      loading="lazy"
                      title="Factory Location"
                    />
                  </div>
                </Card>
              </Col>
            </Row>
          </div>

        </div>
      </Content>
      <Footer />

      {/* PDF VIEWING MODAL */}
      <Modal
        title={currentPdf?.title}
        open={pdfModalOpen}
        onCancel={() => setPdfModalOpen(false)}
        footer={[
          <Button key="close" onClick={() => setPdfModalOpen(false)}>
            Close
          </Button>,
           <Button key="download" type="primary" href={`/${currentPdf?.file}`} target=" blank" download>
            Download PDF
          </Button>
        ]}
        width={900}
        centered
        bodyStyle={{ padding: 0, height: '70vh' }}
      >
        {currentPdf && (
          <iframe 
            src={`/${currentPdf.file}#toolbar=0&view=FitH`} 
            width="100%" 
            height="100%" 
            title={currentPdf.title}
            style={{ border: 'none' }}
          />
        )}
      </Modal>

      {/* CSS For Infinite Marquee Animation */}
      <style>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        
        .marquee-content {
          display: flex;
          width: max-content;
          /* Adjust speed: 40s is slow and smooth */
          animation: scroll 40s linear infinite;
        }

        .marquee-content:hover {
          animation-play-state: paused;
        }
      `}</style>
    </Layout>
  );
}

export default OurCompany;